import moment from "moment-timezone";
const timezone = 'Europe/London'
moment.tz.setDefault(timezone)

export function currentYear(){
  return moment().format("YYYY");
}

export function currentMonth(){
  return moment().format("MM");
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

export function obj2query (obj) {
  return Object.keys(obj).reduce(function (str, key, i) {
    var delimiter, val;
    delimiter = (i === 0) ? '?' : '&';
    key = encodeURIComponent(key);
    val = encodeURIComponent(obj[key]);
    return [str, delimiter, key, '=', val].join('');
  }, '');
}

export function padStart(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export function findObject(arr, value, key = null) {
  if (arr instanceof Array && key) {
    return arr.find(x => x[key] == value);
  }

  if (arr instanceof Array && !key) {
    return arr.find(x => x.id == value);
  }
}

export function findIndex(arr, value, key = null) {
  if (arr instanceof Array && key) {
    return arr.findIndex(x => x[key] == value);
  }

  if (arr instanceof Array && !key) {
    return arr.findIndex(x => x.id == value);
  }
}

export function findObjectArray(arr, value, key) {
  if (arr instanceof Array && key) {
    let obj = [];
    for (var i = 0; i < arr.length; i += 1) {
      if (arr[i][key] === value) {
        obj.push(arr[i]);
      }
    }
    return obj;
  }
}

// bankaccount account_type: "cash" = FX Transaction Ledger, "normal" = Normal Ledger
// server sends raw value (accountType / account_type) or label (account_type) depending on endpoint
export function isCashAccount(bank) {
  const type = bank ? bank.account_type || bank.accountType : "";
  return type === "cash" || type === "FX Transaction Ledger";
}

export function accountTypeLabel(bank) {
  return isCashAccount(bank) ? "FX Transaction Ledger" : "Normal Ledger";
}

// cash account (wallet): customer name + " FX Transaction Ledger"
export function bankAccountName(bank) {
  const name = bank.name || bank.name2 || "";
  return isCashAccount(bank) ? `${name} FX Transaction Ledger` : name;
}

export function dateFormat(value, format) {
  return moment(value).format(format || "MM/DD/YYYY hh:mm");
}

export function currentDateTime(format = "YYYY-MM-DD HH:mm:ss") {
  return moment().format(format);
}

export function currencyFormat(num, symbol = "", isEur = false) {

  if (isEur) {
    return (
      num
      .toFixed(2) // always two decimal digits
      .replace('.', ',') // replace decimal point character with ,
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €'
    ) // use . as a separator
  }

  return (symbol ? symbol+" " : "") + (
    num
    .toFixed(2) // always two decimal digits
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  ) // use . as a separator
  
}

function dateDiff(date1, date2){
  let years = date1.diff(date2, 'year');
  date2.add(years, 'years');

  let months = date1.diff(date2, 'months');
  date2.add(months, 'months');

  let days = date1.diff(date2, 'days');
  date2.add(days, 'days');

  let hours = date1.diff(date2, 'hours');
  date2.add(hours, 'hours');

  let minutes = date1.diff(date2, 'minutes');
  date2.add(minutes, 'minutes');

  let seconds = date1.diff(date2, 'seconds');
  return {years, months, days, hours, minutes, seconds};
}

export function expireDate(date){
  var date1 = moment(date, 'YYYY-MM-DD');
  var date2 = moment();

  var diff = dateDiff(date1, date2)
  let expire = false;
  let text = `${diff.days} day `;

  if(diff.months){
    text += `${diff.months} month `
  }
  if(diff.years){
    text += `${diff.years} year`
  }

  if(diff.days <= 0 && diff.months <= 0 && diff.years <= 0){
    expire = true;
  }
  return { text: text, expire: expire}
  
}

export function firstOfMonth(month){
  if(!month){
    month = new Date();
  }
  const firstDayUTC = new Date(Date.UTC(month.getFullYear(), month.getMonth(), 1));

  const year = firstDayUTC.getUTCFullYear();
  const monthValue = (firstDayUTC.getUTCMonth() + 1).toString().padStart(2, '0');
  const dayValue = firstDayUTC.getUTCDate().toString().padStart(2, '0');

  return `${year}-${monthValue}-${dayValue}`;
}

export function lastOfMonth(month){
  if(!month){
    month = new Date();
  }
  const nextMonthFirstDayUTC = new Date(Date.UTC(month.getFullYear(), month.getMonth() + 1, 1));

  nextMonthFirstDayUTC.setUTCDate(nextMonthFirstDayUTC.getUTCDate() - 1);
  const year = nextMonthFirstDayUTC.getUTCFullYear();
  const monthValue = (nextMonthFirstDayUTC.getUTCMonth() + 1).toString().padStart(2, '0');
  const dayValue = nextMonthFirstDayUTC.getUTCDate().toString().padStart(2, '0');

  return `${year}-${monthValue}-${dayValue}`;
}

export function uuid() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

export function workingStatusList(){ 
  return [
 
  {
    "text": "Full Time Employed",
    "value": "fullTimeEmployed",
  },
  {
    "text": "Part Time Employed",
    "value": "partTimeEmployed",
  },
  {
    "text": "Self Employed",
    "value": "selfEmployed",
  },
  {
    "text": "Unemployed",
    "value": "unemployed",
  },
  {
    "text": "Retired",
    "value": "retired",
  },
];
}

export function salaryList(){ 
  return [

    {
      "text": "£1-£1,000",
      "value": "1,000",
    },
    {
      "text": "£1-£3,000",
      "value": "3,000",
    },
    {
      "text": "£1-£5,000",
      "value": "5,000",
    },
    {
      "text": "£1-£10,000",
      "value": "10,000",
    },
    {
      "text": "£1-£20,000",
      "value": "20,000",
    },
    {
      "text": "£1-£100,000",
      "value": "100,000",
    },
];
}

export function accountUsageList(){ 
  return [

    {
      "value": "digitalAssets",
      "text": "Digital Assets",
    },
    {
      "value": "gamingOrBetting",
      "text": "Gaming Or Betting",
    },
    {
      "value": "socialWelfarePayments",
      "text": "Social Welfare Payments",
    },
    {
      "value": "savings",
      "text": "Savings",
    },
    {
      "value": "salary",
      "text": "Salary",
    },
    {
      "value": "sendAndReceiveMoneyTransfers",
      "text": "Send And Receive Money Transfers",
    },
    {
      "value": "inheritance",
      "text": "Inheritance",
    },
    {
      "value": "investments",
      "text": "Investments",
    },
    {
      "value": "incomeFromBusinessActivity",
      "text": "IncomeFromBusinessActivity",
    },
    {
      "value": "personalExpenses",
      "text": "Personal Expenses",
    },
    {
      "value": "other",
      "text": "Other",
    }
];
}

export function expectedvolumeRangeList(){ 
  return [

    {
      "text": "0-5,000",
      "value": "0-5000",
    },
    {
      "text": "5,001-1,0000",
      "value": "5001-10000",
    },
    {
      "text": "10,000+",
      "value": "10000+",
    },
];
}

export function genderList(){ 
  return [

    {
      "text": "Male",
      "value": "male",
    },
    {
      "text": "Female",
      "value": "female",
    },
    // {
    //   "text": "Other",
    //   "value": "other",
    // },
];
}